import Reflux from "reflux";

const SubmitFormActions = Reflux.createActions([
  "disableButtons",
]);

window.SubmitFormActions = SubmitFormActions;
export default SubmitFormActions;
